import { referenceImageLabel } from "../lib/reference-attachment";

interface ReferenceImagePillProps {
  imageIndex: number;
  /** Data URL or asset URL for the reference image */
  imageDataUrl: string;
  /** Saved-asset name. Falls back to "Reference Image N" when absent. */
  assetName?: string | null;
  onRemove: () => void;
  disabled?: boolean;
}

export function ReferenceImagePill({
  imageIndex,
  imageDataUrl,
  assetName,
  onRemove,
  disabled = false,
}: ReferenceImagePillProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="w-[20px] h-[20px] rounded-sm overflow-hidden flex-shrink-0 bg-[var(--bg-modal)] border border-[var(--stroke-field)]">
        <img
          src={imageDataUrl}
          alt="Reference"
          className="w-full h-full object-cover"
        />
      </div>

      <span className="text-sm text-[var(--text-secondary)] truncate">
        {referenceImageLabel(imageIndex, assetName)}
      </span>

      <button
        type="button"
        onClick={onRemove}
        disabled={disabled}
        className="w-4 h-4 flex items-center justify-center text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Remove reference image"
      >
        <span className="text-lg leading-none">&times;</span>
      </button>
    </div>
  );
}
